module.exports = __webpack_public_path__ + "media/lucina.c4707e1b.wav";